import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import InputMask from "react-input-mask";
import axios from "axios";

import Logo from '../../Images/LogoBunge.png';
import Loading  from "../../Componentes/Carregando";
import { URLBunge } from "../../Componentes/Config"
import { Container, Titulo, ItemRadio, Formulario, ItemCelular, BtnEnviar, SelectForm, ItemSelect, ItemCampoMotivo, Heander } from "./styles";
  

function Descadastramento() {

	const [celular, setCelular] = useState('');
	const [encerrarWa, setEncerrarWa] = useState(false);
	const [motivo, setMotivo] = useState('');
	const [campoLivre, setCampoLivre] = useState('');
	const [motivosLista, setMotivosLista] = useState([]);
	const [carregando, setCarregando] = useState(false);

	async function enviarDados(e) {
		e.preventDefault();
		
		let celularSemCaracteres = celular.replace(/\D/g, '')

		if (celularSemCaracteres.length < 10){
			alert('Atenção', 'Número de celular inválido.', 'warning');
			return;
		}	

		if (motivo === ''){
			alert('Atenção', 'Selecione um motivo.', 'warning');
			return;
		}

		// if (motivo === '3' && campoLivre === ''){
		// 	alert('Atenção', 'Preencha o campo motivo.', 'warning');
		// 	return;
		// }

		setCarregando(true);

		let dados = {
			idMotivo: Number(motivo),
			Observacao: campoLivre.trim(),
			Celular: celularSemCaracteres,
		}

		try {
			const result = await axios.post(`${URLBunge}/api/Descadastramento/InserirDescadastramento`, dados);
			setCarregando(false);

			if (result.data.sucesso) {
				alert('Tudo certo!', 'Dados enviado com sucesso.', 'success');
				limpaCampos();
			} else {
				alert('Ops!', result.data.mensagem, 'warning');
			}

		} catch (erro) {
			console.log('Erro api: (Descadastramento/InserirDescadastramento)', erro)
			alert('Ops!', erro.response.data.mensagem, 'warning');
			setCarregando(false);

		}

	}

	async function buscaListaMotivos(){
		setCarregando(true);

		try {
			const result = await axios.get(`${URLBunge}/api/Descadastramento/BuscarMotivosDescadastramento`);
			setCarregando(false);
	
			if (result.data.sucesso) {
				setMotivosLista(result.data.listaMotivos)
			} else {
				alert('Ops!', 'Ocorreu um erro, tente novamente mais tarde.', 'warning');
			}
		} catch (erro) {
			console.log('Erro api: (Descadastramento/BuscarMotivosDescadastramento)', erro)
			alert('Ops!', 'Ocorreu um erro, tente novamente mais tarde.', 'warning');
			setCarregando(false);

		}
	}

	function limpaCampos() {
		setCelular('');
		setMotivo('');
		setEncerrarWa(false);
		setCampoLivre('');
	}

	function alert(title, text, icon) {
		Swal.fire({
			icon,
			title,
			text
		});
	}

	useEffect(() => {
		document.title = "Minha Bunge Vendas | Descadastramento";
		limpaCampos();
		buscaListaMotivos();
	}, []);

	return (
		<Container>
			{carregando && <Loading />}

			<Heander>
				<img src={Logo} alt="logo" />
			</Heander>
			<Titulo>Descadastramento de comunicações via WA</Titulo>

			<Formulario onSubmit={enviarDados}>
					<span>Deseja parar de receber comunicações via WA?</span>
					<ItemRadio>
						<label htmlFor="sim">Sim</label>
						<input
							type="radio"
							name="sim"
							id="sim"
							checked={encerrarWa}
							onClick={ e => setEncerrarWa(true) }
							title="Funciona"
						/>

						<label htmlFor="nao">Não</label>
						<input
							type="radio"
							name="nao"
							id="nao"
							checked={!encerrarWa}
							onClick={ e => setEncerrarWa(false) }
							title="Funciona"
						/>
					</ItemRadio>

				{encerrarWa &&
					<>
						<ItemCelular>
							<span> Informe o Telefone Celular<em>*</em></span>
							<InputMask
								name="celular"
								id="celular"
								type="tel"
								size="10"
								alt="#"
								autoComplete="off"
								placeholder="(99) 99999-9999"
								value={celular}
								onChange={(e) => {
									setCelular(e.target.value);
								}}
								mask="(99) 99999-9999"
								maskChar={null}
							/>
						</ItemCelular>

						{motivosLista.length > 0 && 
						<ItemSelect>
							<span >Selecione o motivo: </span>
							<SelectForm onChange={(e) => setMotivo(e.target.value) }  id='motivo' >
								<option value='' >Selecione um opção</option>
								{
									motivosLista.map(item => (
										<option key={item.id} value={item.id} >
											{item.motivo}
										</option>
									))
								}
							</SelectForm>
						</ItemSelect>}

						{ motivo === '3' &&
							<ItemCampoMotivo>
								<span>Digite o motivo:</span>
								<input
									name="campo-livre"
									id="campo-livre"
									type="text"
									alt="#"
									autoComplete="off"
									value={campoLivre}
									onChange={(e) => {
										setCampoLivre(e.target.value);
									}}
								/>
							</ItemCampoMotivo>
						}

						<BtnEnviar disabled={motivosLista.length === 0} type='submit'>Enviar</BtnEnviar>
					</>
				}

			</Formulario>

		</Container>
	);
}


export default Descadastramento;


